module.exports = __webpack_public_path__ + "img/3.58eb41b2.png";